module.exports = __webpack_public_path__ + "fonts/emj_skolkovo.f799cb1.eot";